<template>
  <el-card
    class="box-card container--box-card"
    :class="`container--box-card-${item.type}`"
    :shadow="shadow"
  >
    <nuxt-link v-if="hasTo" :to="to" @click.native="handlerClick">
      <LadMediaCard :is-product="isProduct" :item="item" />

      <LadDescriptionCard
        v-if="hasTitleDescription"
        :is-product="isProduct"
        :item="item"
        :base="base"
      />
    </nuxt-link>

    <a v-else-if="hasLink" :href="link" :target="target">
      <LadMediaCard :is-product="isProduct" :item="item" />

      <LadDescriptionCard
        v-if="hasTitleDescription"
        :is-product="isProduct"
        :item="item"
        :base="base"
      />
    </a>

    <template v-else>
      <LadMediaCard :is-product="isProduct" :item="item" />

      <LadDescriptionCard
        v-if="hasTitleDescription"
        :is-product="isProduct"
        :item="item"
        :base="base"
      />
    </template>
  </el-card>
</template>

<script>
import LadSearchCustomLoadingMixin from '@/utils/mixin/search-custom-loading.js'
import LadCardCommon from './common'

export default {
  name: 'LadCardBase',
  extends: LadCardCommon,
  mixins: [LadSearchCustomLoadingMixin],
  computed: {
    hasTitleDescription() {
      return (
        Reflect.has(this.item, 'title') && Reflect.has(this.item, 'description')
      )
    },
    hasTo() {
      return Object.keys(this.to).length > 0
    },
    hasLink() {
      return !!this.link
    },
    isProduct() {
      return ['experience', 'package'].includes(this.item.type)
    },
  },
  methods: {
    handlerClick(event) {
      this.handleLoading(event)

      if (typeof this.$gtag !== 'undefined' && this.isProduct) {
        let price = this.item.total_amount

        if (this.item.promotions.length > 0) {
          const promotion = this.item.promotions[0]

          const isCurrentPromotion = Date.parse(promotion.end) >= Date.now()

          if (promotion.rules.length > 0) {
            price = promotion.rules[0].condition.includes(this.currency)
              ? this.item.total_amount * (1 - promotion.value / 100)
              : this.item.total_amount
          } else if (isCurrentPromotion) {
            price = this.item.total_amount * (1 - promotion.value / 100)
          }
        }

        this.$gtag('event', 'eec.productClick', {
          ecommerce: {
            click: {
              products: [
                {
                  name: this.item.title,
                  id: this.item.uuid,
                  price: price === 0 ? '' : price.toFixed(2).toString(),
                },
              ],
            },
          },
          eventCallback() {
            document.location = this.$route.fullPath
          },
          page_title: this.$metaInfo.title,
          page_location: window.location.href,
        })
      }
    },
  },
}
</script>

<style lang="scss">
.container--box-card {
  .el-card__body {
    padding: 0;
  }

  a[href] {
    display: block;
  }
}
</style>
